import React, { useState, useEffect } from 'react'
import Header from '../../components/Header/Header'
import bannerImg from "../../assets/images/comparateur.jpg"
import "./Comparateur.css"
import { institutions_data } from "../../fakeData/institutions.jsx"
import { products_categories_data } from "../../fakeData/productsCategories.jsx"
import Select, { StylesConfig } from 'react-select';
import { GiBlackball } from 'react-icons/gi'
import InstitutionComparateurCard from '../../components/InstitutionComparateurCard/InstitutionComparateurCard'
import AverageRateComparasionRow from '../../components/AverageRateComparasionRow/AverageRateComparasionRow'
import { useNavigate } from 'react-router-dom'
import { getAllCategoryAndZone, getInstitutionFromCategoryAndZone, getInstitutionRate, getInstitutionsComparisionData } from '../../services/http'


const Comparateur = () => {

  const [firstInstitutions, setFirstInstitutions] = useState([])
  const [secondInstitutions, setSecondInstitutions] = useState([])
  const [thirdInstitutions, setThirdInstitutions] = useState([])
  const [institutionsCategory, setInstitutionsCategory] = useState([])
  const [institutionsZone, setInstitutionsZone] = useState([])
  const [firstInstitution, setFirstInstitution] = useState({ value: "", label: "", telephone: "", email: "", image: "", tauxMoyens: [] })
  const [secondInstitution, setSecondInstitution] = useState({ value: "", label: "", telephone: "", email: "", image: "", tauxMoyens: [] })
  const [thirdInstitution, setThirdInstitution] = useState({ value: "", label: "", telephone: "", email: "", image: "", tauxMoyens: [] })
  const [productsCategories, setProductsCategories] = useState([])
  const [comparasionData, setDataComparasion] = useState([])
  // const [comparasionData, setDataComparasion] = useState([{category: "", rates :{first: "", second: "", third :""}}])
  const [firstCategory, setFirstCategory] = useState({ value: "", label: "" })
  const [secondCategory, setSecondCategory] = useState({ value: "", label: "" })
  const [thirdCategory, setThirdCategory] = useState({ value: "", label: "" })

  const [firstZone, setFirstZone] = useState({ value: "", label: "" })
  const [secondZone, setSecondZone] = useState({ value: "", label: "" })
  const [thirdZone, setThirdZone] = useState({ value: "", label: "" })

  const [firstInstitutionDetails, setFirstInstitutionDetails] = useState()
  const [secondInstitutionDetails, setSecondInstitutionDetails] = useState()
  const [thirdInstitutionDetails, setThirdInstitutionDetails] = useState()

  

const [institutionsToCompare, setInstitutionsToCompare] = useState([])

const [comparateurData, setComparateurData] = useState()

  const navigate = useNavigate();

// To load Categories and zones filters
  const loadCategoriesAndZones = async () => {
    const req = await getAllCategoryAndZone()
    if (req.response && req.reponse.status !== 200) {
      console.log(req.response)
    } else {
      console.log("Okay", req)
      const zoneData = req.data?.zone?.map(value => ({
        value: value.id,
        label: value.libelle,
      }))

      setInstitutionsZone(zoneData)

      const categoryData = req.data?.category?.map(value => ({
        value: value.id,
        label: value.libelle,
      }))

      setInstitutionsCategory(categoryData)
    }
  }

  // To load Institutions depending on Categopries and Zones
  const loadInstitutions = async (position) => {
    if(position == "first"){
      const req = await getInstitutionFromCategoryAndZone(firstCategory.value, firstZone.value)
      if (req.response && req.reponse.status !== 200) {
        console.log(req.response)
      } else {
        console.log("Primo", req)
        const firstInstitutionsData = req.data?.map(value => ({
          value: value.institution_id,
          label: value.libelle,
        }))
        setFirstInstitutions(firstInstitutionsData)
    }
    }
    if(position == "second"){
      const req = await getInstitutionFromCategoryAndZone(secondCategory.value, secondZone.value)
      if (req.response && req.reponse.status !== 200) {
        console.log(req.response)
      } else {
        console.log("Secondo", req)
        const secondInstitutionsData = req.data?.map(value => ({
          value: value.institution_id,
          label: value.libelle,
        }))
        setSecondInstitutions(secondInstitutionsData)
    }
    }
    if(position == "third"){
      const req = await getInstitutionFromCategoryAndZone(thirdCategory.value, thirdZone.value)
      if (req.response && req.reponse.status !== 200) {
        console.log(req.response)
      } else {
        console.log("Tertio", req)
        const thirdInstitutionsData = req.data?.map(value => ({
          value: value.institution_id,
          label: value.libelle,
        }))
        setThirdInstitutions(thirdInstitutionsData)
    }
    }
  }

  // Load First Level of Institutions
    useEffect(() => {
      loadInstitutions("first")
    }, [firstCategory, firstZone]);

  // Load Second Level of Institutions
    useEffect(() => {
      loadInstitutions("second")
    }, [secondCategory, secondZone]);

  // Load Third Level of Institutions
    useEffect(() => {
      loadInstitutions("third")
    }, [thirdCategory, thirdZone]);

const rateInstit = [
  {
    "Prêt d'investissement": 1.25,
    "Prêt commercial": 7.66,
    "Crédit de trésorerie": 1.33,
    "Prêt à la consommation": 4.11
    },
    {
      "Prêt d'investissement": 1.22,
      "Prêt commercial": 7.06,
      "Crédit de trésorerie": 1.83,
      "Prêt à la consommation": 4.81
      },
      {
        "Prêt d'investissement": 1.22,
        "Prêt commercial": 2.16,
        "Crédit de trésorerie": 3.83,
        "Prêt à la consommation": 3.21
        }
]


const loadInstitutionsToCompare = async () => {
  const tempArray = []
  if(firstInstitution.value){
    tempArray.push(firstInstitution.value)
  }
  if(secondInstitution.value){
    tempArray.push(secondInstitution.value)
  }
  if(thirdInstitution.value){
    tempArray.push(thirdInstitution.value)
  }

  if(tempArray?.length >= 2){
    // const response = await getInstitutionsComparisionData(tempArray)
    // if (response.response && response.reponse.status !== 200) {
    //   console.log(response.response)
    // } else { 
    //   console.log(response)
    // }
  }
}

// const loadInstitutionRate = async () => {

// }

useEffect(() => {
  loadInstitutionsToCompare()
}, [firstInstitution, secondInstitution, thirdInstitution]);

  useEffect(() => {

    loadCategoriesAndZones();

  }, []);

  // useEffect(() => {
  //   // const [comparasionData, setDataComparasion] = useState([{category: "", rates :{first: "", second: "", third :""}}])
  //   var tempArray = []

  //   var first, second, third;

  //   productsCategories.map(productsCategory => {
  //     firstInstitution.tauxMoyens.map(item => {
  //       console.log(item)
  //       console.log(productsCategory)
  //       if (item.label === productsCategory.libelle) {
  //         first = item.value;
  //       } else {
  //         first = 0.00
  //       }

  //     })
  //     secondInstitution.tauxMoyens.map(item => {
  //       console.log(item)
  //       console.log(productsCategory)
  //       if (item.label === productsCategory.libelle) {
  //         second = item.value;
  //       } else {
  //         second = 0.00
  //       }

  //     })
  //     thirdInstitution.tauxMoyens.map(item => {
  //       console.log(item)
  //       console.log(productsCategory)
  //       if (item.label === productsCategory.libelle) {
  //         third = item.value;
  //       } else {
  //         third = 0.00
  //       }

  //     })

  //     tempArray.push({ label: productsCategory.libelle, firstRate: first, secondRate: second, thirdRate: third })
  //   })

  //   console.log("TempArray =====> ", tempArray)

  // }, [firstInstitution, secondInstitution, thirdInstitution])



// To set zone and category on selection
  const selection = (key, e) => {
    if (key === "first-zone") {
      setFirstZone({ value: e.value, label: e.label })
    }
    if (key === "second-zone") {
      setSecondZone({ value: e.value, label: e.label })
    }
    if (key === "third-zone") {
      setThirdZone({ value: e.value, label: e.label })
    }
    if (key === "first-category") {
      setFirstCategory({ value: e.value, label: e.label })
    }
    if (key === "second-category") {
      setSecondCategory({ value: e.value, label: e.label })
    }
    if (key === "third-category") {
      setThirdCategory({ value: e.value, label: e.label })
    }
  }

  // To load Instituion details for each level
const loadInstitutionDetails = async (key, institutionId) => {
if (key == 0) {
  const req = await getInstitutionRate(institutionId)
  if (req.response && req.reponse?.status !== 200) {
    console.log(req.response)
  } else {
    console.log(req.data)
    setFirstInstitutionDetails(req.data)
    setProductsCategories(Object.keys(req.data.taux))
    // console.log(Object.keys(req.data.taux))
  }
}
if (key == 1) {
  const req = await getInstitutionRate(institutionId)
  console.log(req)
  if (req.response && req.reponse?.status !== 200) {
    console.log(req.response)
  } else {
    console.log(req.data)
    setSecondInstitutionDetails(req.data)
    setProductsCategories(Object.keys(req.data.taux))
  }
}
if (key == 2) {
  const req = await getInstitutionRate(institutionId)
  if (req.response && req.reponse?.status !== 200) {
    console.log(req.response)
  } else {
    console.log(req.data)
    setThirdInstitutionDetails(req.data)
    setProductsCategories(Object.keys(req.data.taux))
  }
}
}

useEffect(() => {
  if(firstInstitution.value) {
    loadInstitutionDetails(0, firstInstitution.value)
  }
  if(secondInstitution.value) {
    loadInstitutionDetails(1, secondInstitution.value)
  }
  if(thirdInstitution.value) {
    console.log(thirdInstitution)
    loadInstitutionDetails(2, thirdInstitution.value)
  }

}, [firstInstitution, secondInstitution, thirdInstitution]);


const loadComparateurData = () => {
  console.log("new Data ", firstInstitutionDetails)
  console.log("new Data ", secondInstitutionDetails)
  console.log("new Data ", thirdInstitutionDetails)
  console.log("new Data ", productsCategories)
  if(productsCategories?.length != 0) {
    
    const newData = [] ;
    productsCategories?.map(item => (
      newData.push({
      label: item,
      rate: {first: parseFloat(firstInstitutionDetails?.taux[item]).toFixed(2), second: parseFloat(secondInstitutionDetails?.taux[item]).toFixed(2), third: parseFloat(thirdInstitutionDetails?.taux[item]).toFixed(2)},

    })))
    console.log("new Data ", newData)
    console.log(firstInstitutionDetails?.taux)
    setComparateurData(newData)
    // console.log(firstInstitutionDetails.taux["Prêt commercial"])
  }
}

useEffect(() => {
  
loadComparateurData()
}, [firstInstitutionDetails, secondInstitutionDetails, thirdInstitutionDetails]);
useEffect(() => {
console.log(firstInstitutionDetails)
console.log(secondInstitutionDetails?.taux)
console.log("comparateur Data", comparateurData)
}, [productsCategories]);

  const institutionSelection =  (key, e) => {
    if (key == 0) {
      setFirstInstitution({ value: e.value, label: e.label, email: e.email, telephone: e.telephone, image: e.image, tauxMoyens: e.tauxMoyens })
    }
    if (key == 1) {
      setSecondInstitution({ value: e.value, label: e.label, email: e.email, telephone: e.telephone, image: e.image, tauxMoyens: e.tauxMoyens })
    }
    if (key == 2) {
      console.log(e)
      setThirdInstitution({ value: e.value, label: e.label, email: e.email, telephone: e.telephone, image: e.image, tauxMoyens: e.tauxMoyens })
    console.log("here")
    }
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      // background: "#023950",
      color: "black",
      padding: "0px",
      borderColor: state.isFocused ? "#454655" : "#cccccc",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,

    }),
    placeholder: (base) => ({
      ...base,
      color: "#cccccc"
    })
  };

  return (
    <div id="comparateur">
      <Header bannerImg={bannerImg} title={"Comparateur"} />
      <div className="d-flex">
        <div className="w-25"></div>
        <div className='w-75 row pt-3 comparateur-filter-box' >
          <div className='col-sm-4 col-xs-12'>
            <p className='t-primary-color'>Zone : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("first-zone", e)}
                placeholder={<div className="select-placeholder-text">Select category</div>}
                classNamePrefix="select"
                value={firstZone}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsZone}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
            </div>
            <p className='t-primary-color'>Catégorie : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("first-category", e)}
                placeholder=""
                classNamePrefix="select"
                value={firstCategory}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsCategory}
                styles={customStyles}
                noOptionsMessage={() => "Aucune Option"}
              />
            </div>
            <p className='t-primary-color'>Comparer : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => institutionSelection(0, e)}
                placeholder=""
                classNamePrefix="select"
                value={firstInstitution}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={firstInstitutions}
                noOptionsMessage={() => "Aucune Option"}
                // styles={customStyles}
              />
              <p className='text-muted text-indic'>Veuillez entrer le nom de l’établissement en entier ou en partie.</p>

              {firstInstitution.value !== "" ? <InstitutionComparateurCard
                id={firstInstitutionDetails?.institution?.id}
                libelle={firstInstitutionDetails?.institution?.libelle}
                email={firstInstitutionDetails?.institution?.email}
                telephone={firstInstitutionDetails?.institution?.telephone}
                image={firstInstitutionDetails?.institution?.logo}
              /> : null}
            </div>
          </div>
          <div className='col-sm-4 col-xs-12'>
            <p className='t-primary-color'>Zone : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("second-zone", e)}
                placeholder="Zone"
                classNamePrefix="select"
                value={secondZone}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsZone}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
            </div>
            <p className='t-primary-color'>Catégorie : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("second-category", e)}
                placeholder=""
                classNamePrefix="select"
                value={secondCategory}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsCategory}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
            </div>
            <p className='t-primary-color'>Avec : </p>
            <div className='col-sm-11 col-xs-12 mx-auto'>
              <Select
                onChange={(e) => institutionSelection(1, e)}
                placeholder=""
                classNamePrefix="select"
                value={secondInstitution}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={secondInstitutions}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
              <p className='text-muted text-indic'>Veuillez entrer le nom de l’établissement en entier ou en partie.</p>


              {secondInstitution.value !== "" ? <InstitutionComparateurCard
                id={secondInstitutionDetails?.institution?.id}
                libelle={secondInstitutionDetails?.institution?.libelle}
                email={secondInstitutionDetails?.institution?.email}
                telephone={secondInstitutionDetails?.institution?.telephone}
                image={secondInstitutionDetails?.institution?.logo}
              /> : null}
            </div>
          </div>
          <div className='col-sm-4 col-xs-12'>
            <p className='t-primary-color'>Zone : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("third-zone", e)}
                placeholder={"Zone"}
                classNamePrefix="select"
                value={thirdZone}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsZone}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
            </div>
            <p className='t-primary-color'>Catégorie : </p>
            <div className='col-sm-11 col-xs-12 mx-auto mb-2'>
              <Select
                onChange={(e) => selection("third-category", e)}
                placeholder=""
                classNamePrefix="select"
                value={thirdCategory}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={institutionsCategory}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
            </div>
            <p className='t-primary-color'>Et avec : </p>
            <div className='col-sm-11 col-xs-12 mx-auto'>
              <Select
                onChange={(e) => institutionSelection(2, e)}
                placeholder=""
                classNamePrefix="select"
                value={thirdInstitution}
                isDisabled={false}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                name="institution-category"
                options={thirdInstitutions}
                noOptionsMessage={() => "Aucune Option"}
                styles={customStyles}
              />
              
              <p className='text-muted text-indic'>Veuillez entrer le nom de l’établissement en entier ou en partie.</p>


              {thirdInstitution.value !== "" ? <InstitutionComparateurCard
                id={thirdInstitutionDetails?.institution?.id}
                libelle={thirdInstitutionDetails?.institution?.libelle}
                email={thirdInstitutionDetails?.institution?.email}
                telephone={thirdInstitutionDetails?.institution?.telephone}
                image={thirdInstitutionDetails?.institution?.logo}
              /> : null}
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 mx-auto my-2 mr-3">

        {comparateurData !== null && comparateurData?.map(item => 

        <AverageRateComparasionRow label={item.label} first={!item.rate?.first ? 0 : item.rate?.first} second={!item.rate?.second ? 0 : item.rate?.second} third={!item.rate?.third ? 0 : item.rate.third} />
        )}

        {/* <AverageRateComparasionRow label={"Crédit de trésorerie"} first={7.51} second={10.52} third={2.24}/>
        <AverageRateComparasionRow label={"Prêt commercial"} first={7.51} second={10.52} third={2.24} /> */}
      </div>
      <div className="d-flex mb-5">
        <div className="w-25"></div>
        <div className='w-75 row pt-3' >
          <div className='col-sm-4 col-xs-12'>
            <div className='col-sm-11 col-xs-12 mx-auto view-institution'>

              {firstInstitution.value !== "" ? <p style={{ cursor: 'pointer', marginBottom: 0 }} onClick={() => navigate(`/institution/${firstInstitution.value}`)}>Voir tous les produits de <span className='t-primary-color t-bold'>{firstInstitution.label}</span> </p> : null}

            </div>
          </div>
          <div className='col-sm-4 col-xs-12'>
            <div className='col-sm-11 col-xs-12 mx-auto view-institution'>


              {secondInstitution.value !== "" ? <p style={{ cursor: 'pointer', marginBottom: 0 }} onClick={() => navigate(`/institution/${secondInstitution.value}`)}>Voir tous les produits de <span className='t-primary-color t-bold'>{secondInstitution.label}</span> </p> : null}

            </div>
          </div>
          <div className='col-sm-4 col-xs-12'>
            <div className='col-sm-11 col-xs-12 mx-auto view-institution'>


              {thirdInstitution.value !== "" ? <p style={{ cursor: 'pointer', marginBottom: 0 }} onClick={() => navigate(`/institution/${thirdInstitution.value}`)}>Voir tous les produits de <span className='t-primary-color t-bold'>{thirdInstitution.label}</span> </p> : null}
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Comparateur